import { Component, OnInit, Input, ViewChild, Inject } from "@angular/core";
import { TPRDataService } from "../tpr-data.service";
import { Subscription, throwError } from "rxjs";
import {
  VAIconRegistryService,
  closeCircle,
  infoCircle,
  folder,
  download,
  print,
  republish,
  questionCircle,
  chevronLeft,
  chevronRight,
  guidance,
  corporateAction,
  sync,
} from "@va/core-library/icons";
import {
  BROKER_DETAIL_GRID_DEFAULT_COLUMNS,
  BROKER_DETAIL_GRID_DEFAULT_SORTING_ID,
  TPR_BROKER_DETAIL_COLUMN_PICKER_ITEMS,
  COMPANY_TAB,
  INDIVIDUAL_CONTRIBUTOR_DISCLAIMERS,
} from "../tpr-constants";
import {
  mapBrokerDetailsGridData,
  getSortingDetails,
  createBrokerDetailsGridData,
  getBrokerDetailsGridFields,
  getBrokerDetailsGridColumnData,
  getBrokerDetailsColumnWidth,
  getSortesArrayKeys,
} from "../broker-details-grid-utils";
import {
  updateColumnPickerData,
  getAddedAndRemovedColumnPickerItemsLabels,
} from "../tpr-utils";
import {
  MARKETDATA_COPYRIGHT_MESSAGE,
  LEGACY_URL,
} from "src/app/common-constants";
import { ConsensusSummaryDataService } from "../consensus-summary/consensus-summary-data.service";
import { catchError } from "rxjs/operators";
import { CompanyDataService } from "../../company-page/company-data.service";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { getSelectedColumnPickerItemId } from "src/app/utils/common";
import { CustomGridComponent } from "@va/core-library/custom-grid";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import { HttpClient } from "@angular/common/http";
import {
  DeleteDpParams,
  SetDpParams,
} from "src/app/store/actions/global-subheader.actions";
import { AppService } from "src/app/app.service";
import { TPR_LOG_ACTION_FEATURES, TPR_PAGE } from "src/app/tpr/tpr-constants";
import { NzMessageService } from "ng-zorro-antd/message";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CompanyAnnouncementDialogComponent } from "src/app/shared/company-announcement-dialog/company-announcement-dialog.component";
import { MatSnackBarRef } from "@angular/material/snack-bar";
import { DOCUMENT, DatePipe } from "@angular/common";
@Component({
  selector: "app-tpr-company-broker-grid",
  templateUrl: "./tpr-company-broker-grid.component.html",
  styleUrls: ["./tpr-company-broker-grid.component.scss"],
})
export class TprCompanyBrokerGridComponent implements OnInit {
  //inputs, outputs
  @Input() primaryTicker = "";
  @Input() isTabVisible;

  //instance variables
  primaryTickerCompanyId;
  gridColumnsData = [];
  originallySelectedColumnsPickerData = [];
  gridFields = [];
  gridData;
  gridDataMapping;
  gridColumnWidthConfig = [];
  gridColumnFreezeConfig = [
    {
      nzLeft: "0px",
    },
  ];
  gridAverageData;
  gridMedianData;
  columnPickerData = [...TPR_BROKER_DETAIL_COLUMN_PICKER_ITEMS];
  marketDataCopyRightMessage = MARKETDATA_COPYRIGHT_MESSAGE;
  individualContributorDisclaimers = INDIVIDUAL_CONTRIBUTOR_DISCLAIMERS;
  gridDataSortingDetails;
  notEntitledSourceMessage = "";
  defaultColumnForSorting = BROKER_DETAIL_GRID_DEFAULT_SORTING_ID;
  normalizedRatingFilterSelection = -1;
  sortKeysArr = [];
  viewFilingModalSrc: SafeResourceUrl;
  filingsError = false;
  selectedSourceId: number;
  currenySymbol: string;
  selectedCellId;
  selectedRowId;
  sortKey = BROKER_DETAIL_GRID_DEFAULT_SORTING_ID;
  sortOrder = "descend";
  filingFileType;
  hasGuidance;
  viewModalSrc: SafeResourceUrl;

  //loader
  isBrokerDetailsGridApiInProgress = true;
  isTprColumnDetailsSaveApiInProgress = false;
  gettingPDFURL = false;

  //popover
  isFilingModalVisible = false;
  isColumnPickerModalVisible = false;
  isDocumentModalOpen = false;
  filingsHeading: string;
  datePublish: string;
  documentType: string;
  documentId: number;
  currentGuidance = 0;
  guidanceCount: number;
  guidanceList;

  //excel export
  excelToExportDropdownOptions = [
    {
      label: "Values",
      id: 1,
      disabled: false,
    },
    {
      label: "Excel Add-In Formulas",
      id: 0,
      disabled: false,
    },
  ];
  isExportPopoverVisible = false;
  isExportInProgress = false;
  //snackbar
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  //icons
  faInfoCircle = faInfoCircle;

  //subscribers
  companyBrokerDetailsSubscriber: Subscription;
  selectedConsensusDistributionSubscriber: Subscription;
  saveTprColumnDetailSubscriber: Subscription;

  @ViewChild(CustomGridComponent)
  customGridComp: CustomGridComponent;

  private dialogRef: MatDialogRef<CompanyAnnouncementDialogComponent>;

  constructor(
    private dataService: TPRDataService,
    private iconRegistry: VAIconRegistryService,
    private consensusSummaryDataService: ConsensusSummaryDataService,
    private companyDataService: CompanyDataService,
    public sanitizer: DomSanitizer,
    private http: HttpClient,
    private store: Store<AppState>,
    private appService: AppService,
    private message: NzMessageService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    public dialog: MatDialog,
  ) {
    this.iconRegistry.registerIcons([
      closeCircle,
      infoCircle,
      folder,
      download,
      print,
      republish,
      questionCircle,
      chevronLeft,
      chevronRight,
      guidance,
      corporateAction,
      sync,
    ]);
  }

  ngOnInit() {
    // get grid data
    this.fetchAndUpdateBrokerDetailGrid();

    this.selectedConsensusDistributionSubscriber =
      this.consensusSummaryDataService.selectedConsensusDistribution$.subscribe(
        (data) => {
          if (data) {
            if (data !== this.normalizedRatingFilterSelection) {
              this.normalizedRatingFilterSelection = data;
              this.gridData = createBrokerDetailsGridData(
                this.sortKeysArr,
                this.gridDataMapping,
                this.normalizedRatingFilterSelection,
                this.gridAverageData,
                this.gridMedianData,
                this.currenySymbol,
              );
            }
          }
        },
      );
  }

  ngOnChanges(changes) {
    if (
      changes &&
      changes.isTabVisible.currentValue !== changes.isTabVisible.previousValue
    ) {
      if (this.selectedCellId) {
        this.selectedCellId = "";
      }
      if (this.selectedRowId) {
        this.selectedRowId = "";
      }
    }
  }

  ngOnDestroy() {
    if (this.companyBrokerDetailsSubscriber) {
      this.companyBrokerDetailsSubscriber.unsubscribe();
    }
    if (this.selectedConsensusDistributionSubscriber) {
      this.selectedConsensusDistributionSubscriber.unsubscribe();
    }
    if (this.saveTprColumnDetailSubscriber) {
      this.saveTprColumnDetailSubscriber.unsubscribe();
    }
    this.selectedCellId = "";
    this.selectedRowId = "";
  }

  fetchAndUpdateBrokerDetailGrid() {
    this.isBrokerDetailsGridApiInProgress = true;
    this.companyBrokerDetailsSubscriber = this.dataService
      .getTprCompanyBrokerDetails(this.primaryTicker)
      .pipe(
        catchError((err) => {
          console.error(err);
          return throwError(err);
        }),
      )
      .subscribe((response) => {
        if (response && response.status === "success" && response.data) {
          const data = response.data;
          this.gridAverageData = data.average;
          this.gridMedianData = data.median;
          this.currenySymbol = data.display_cur || "";
          const functionHandlers = {
            handleCompanyDocumentClick:
              this.handleCompanyDocumentClick.bind(this),
            handleCompanyFillingClick:
              this.handleCompanyFillingClick.bind(this),
            handleDPCellClick: this.handleDPCellClick.bind(this),
            analystEmailClick: this.handleAnalystEmailClick.bind(this),
          };
          const selectedGridColumns =
            data.grid_columns || BROKER_DETAIL_GRID_DEFAULT_COLUMNS;

          // reset the grid before creating the datay
          if (this.gridColumnsData && this.gridColumnsData.length) {
            this.customGridComp.resetAll();
          }

          this.gridColumnsData =
            getBrokerDetailsGridColumnData(selectedGridColumns);
          this.gridColumnWidthConfig =
            getBrokerDetailsColumnWidth(selectedGridColumns);
          this.gridFields = getBrokerDetailsGridFields(selectedGridColumns);
          this.gridDataMapping = mapBrokerDetailsGridData(
            data.values,
            functionHandlers,
            this.currenySymbol,
          );
          this.gridDataSortingDetails = getSortingDetails(data);
          this.sortKeysArr =
            this.gridDataSortingDetails[this.defaultColumnForSorting].descend;
          this.gridData = createBrokerDetailsGridData(
            this.sortKeysArr,
            this.gridDataMapping,
            this.normalizedRatingFilterSelection,
            this.gridAverageData,
            this.gridMedianData,
            this.currenySymbol,
          );
          const columnPickerData = updateColumnPickerData(
            this.columnPickerData,
            selectedGridColumns,
          );
          this.columnPickerData = [...columnPickerData];
          this.originallySelectedColumnsPickerData = [...columnPickerData];
          this.notEntitledSourceMessage = data.not_entitled_sources_message;
          this.primaryTickerCompanyId = data.companyid;
        }
        this.isBrokerDetailsGridApiInProgress = false;
      });
  }

  handleCompanyBrokerDetailStortChange(data) {
    const valueObj = data[0];
    this.sortKey = valueObj.key;
    this.sortOrder = valueObj.value;
    this.sortKeysArr = getSortesArrayKeys(
      this.sortKey,
      this.sortOrder,
      this.gridDataSortingDetails,
    );
    this.gridData = createBrokerDetailsGridData(
      this.sortKeysArr,
      this.gridDataMapping,
      this.normalizedRatingFilterSelection,
      this.gridAverageData,
      this.gridMedianData,
      this.currenySymbol,
    );
    this.appService.logUserAction(
      {},
      this.primaryTicker,
      "",
      TPR_LOG_ACTION_FEATURES.companyBrokerGridSort,
      {
        column: this.sortKey,
        sort_direction: this.sortOrder || "default",
      },
      "",
      TPR_PAGE,
    );
  }

  handleCompanyDocumentClick(value) {
    if (value.document_clickable) {
      this.selectedSourceId = value.source_id;
      this.isDocumentModalOpen = true;
      this.appService.logUserAction(
        {},
        this.primaryTicker,
        "",
        TPR_LOG_ACTION_FEATURES.companyDocumentsOpened,
        {
          source: value.broker,
        },
        "",
        TPR_PAGE,
      );
    }
  }

  handleCompanyFillingClick(value) {
    this.filingsHeading = `<b>${value.broker} |</b> ${
      this.gridDataMapping[value.id].publish_date["textTooltip"]
    }`;
    this.documentType = value.documentType;
    this.datePublish = `${new DatePipe("en-US").transform(
      this.gridDataMapping[value.id].publish_date["dateValue"],
      "dd-MMM-yy",
    )} (${this.gridDataMapping[value.id].publish_date["dayDiff"]})`;

    this.currentGuidance = 0;
    this.guidanceCount = 0;
    if (value.fileType === "xlsx") {
      this.message.error(
        "Error: This filings document is in excel format and cannot be viewed",
        {
          nzDuration: 3000,
        },
      );
      return;
    }
    const params = {
      downloadType: "filings",
      documentId: value.documentId,
      companyId: this.primaryTickerCompanyId,
      pg: "IS",
      cut: "NMV",
      file_type: value.fileType,
    };
    this.filingsError = false;
    const param = {
      documentId: value.documentId,
    };
    this.documentId = value.documentId;
    this.companyDataService.getViewModelSrc(params).subscribe((msg) => {
      this.filingFileType = msg["fileType"];
      if ((msg && msg["fileType"] === "htm") || msg["fileType"] === "html") {
        //load modal with src
        // this.isFilingModalVisible = true;
        const options = {
          responseType: "text" as const,
        };
        this.hasGuidance = msg.guidance;
        this.openFilingDialog();
        if (msg.guidance) {
          this.companyDataService.getGuidanceData(param).subscribe(
            (response) => {
              const doc =
                document.getElementById("filingsFrame")["contentWindow"]
                  .document;
              if (doc && response) {
                doc.open();
                doc.write(response);
                doc.close();
                setTimeout(() => {
                  this.companyDataService
                    .getGuidanceList(param)
                    .subscribe((response) => {
                      this.guidanceList = response["data"].guidances;
                      this.guidanceCount = this.guidanceList.length;
                      if (this.dialogRef?.componentInstance) {
                        this.dialogRef.componentInstance.data = {
                          ...this.dialogRef.componentInstance.data,
                          guidanceCount: this.guidanceCount,
                        };
                      }
                      const filingsDocClass = document
                        .getElementById("filingsFrame")
                        ["contentWindow"].document.getElementsByClassName(
                          "bkmk_filings_span_class",
                        );
                      for (let i = 0; i < filingsDocClass.length; i++) {
                        filingsDocClass[i].style.backgroundColor = "#FFEFCB";
                      }
                    });
                }, 1000);
              }
            },
            (error) => {
              console.error(error);
            },
          );
        } else {
          this.http.get(msg.url, options).subscribe(
            (htmlData) => {
              const doc =
                document.getElementById("filingsFrame")["contentWindow"]
                  .document;
              if (doc && htmlData) {
                doc.open();
                doc.write(htmlData);
                doc.close();
              }
            },
            (error) => {
              console.error(error);
            },
          );
        }
      }
      if (msg["fileType"] === "pdf") {
        const options = {
          responseType: "arraybuffer",
        };
        const filingsParams = {
          documentId: value.documentId,
        };
        // this.isFilingModalVisible = true;
        this.openFilingDialog();
        this.gettingPDFURL = true;
        this.companyDataService.getPDFFilings(filingsParams, options).subscribe(
          (pdfData) => {
            if (pdfData["status"] === "error") {
              console.error(pdfData["message"]);
            } else {
              const file = new Blob([pdfData], { type: "application/pdf" });
              const fileURL = URL.createObjectURL(file);
              this.viewFilingModalSrc =
                this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
              this.filingsError = false;
              this.gettingPDFURL = false;
              if (this.dialogRef?.componentInstance) {
                this.dialogRef.componentInstance.data = {
                  ...this.dialogRef.componentInstance.data,
                  gettingPDFURL: this.gettingPDFURL,
                  filingsError: this.filingsError,
                  viewModalSrc: this.viewFilingModalSrc,
                };
              }
            }
          },
          (error) => {
            console.error(error);
          },
        );
      }
      if (msg.status === "error") {
        //show error
        this.filingsError = true;
        // this.isFilingModalVisible = true;
        this.openFilingDialog();
      }

      if (msg.force_logout) {
        window.location.href = `${LEGACY_URL}/homepage/?force_logout=true`;
      }
      this.appService.logUserAction(
        {},
        this.primaryTicker,
        "",
        this.hasGuidance
          ? TPR_LOG_ACTION_FEATURES.companyFilingsWithGuidanceOpened
          : TPR_LOG_ACTION_FEATURES.companyFilingsWithoutGuidanceOpened,
        {
          documentId: this.documentId,
        },
        "",
        TPR_PAGE,
      );
    });
  }
  openFilingDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.dialogRef = this.dialog.open(CompanyAnnouncementDialogComponent, {
      width: "800px",
      height: "558px",
      panelClass: "resizable-mat-dialog-panel",
      hasBackdrop: true,
      data: {
        filingsHeading: this.filingsHeading,
        gettingPDFURL: this.gettingPDFURL,
        documentType: this.documentType,
        datePublish: this.datePublish,
        hasGuidance: this.hasGuidance,
        filingFileType: this.filingFileType,
        filingsError: this.filingsError,
        guidanceCount: this.guidanceCount,
        currentGuidance: this.currentGuidance,
        viewModalSrc: this.viewModalSrc,
        cut: "NMV",
        documentId: this.documentId,
        ticker: this.primaryTicker,
      },
    });

    this.dialogRef.componentInstance.closeClicked.subscribe(() => {
      this.closeFilingDialog();
    });

    this.dialogRef.componentInstance.onNextGuidanceClicked.subscribe(() => {
      this.onNextGuidance();
    });

    this.dialogRef.componentInstance.onPrevGuidanceClicked.subscribe(() => {
      this.onPrevGuidance();
    });
  }

  closeFilingDialog() {
    if (this.dialogRef) {
      this.hasGuidance = false;
      this.dialogRef.close();
    }
  }

  onNextGuidance() {
    if (this.currentGuidance < this.guidanceCount) {
      this.currentGuidance += 1;
      if (this.dialogRef?.componentInstance) {
        this.dialogRef.componentInstance.data = {
          ...this.dialogRef.componentInstance.data,
          currentGuidance: this.currentGuidance,
        };
      }
      const guidanceId =
        this.guidanceList[this.currentGuidance - 1].start_tag_id;
      const filingsDoc = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementById(guidanceId);
      filingsDoc.scrollIntoView();
      const currFilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(`bkmk_${guidanceId}`);
      const allfilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(
          "bkmk_filings_span_class",
        );
      for (let i = 0; i < allfilingsDocClass.length; i++) {
        allfilingsDocClass[i].style.backgroundColor = "#FFEFCB";
      }
      for (let i = 0; i < currFilingsDocClass.length; i++) {
        currFilingsDocClass[i].style.backgroundColor = "#FFC846";
      }

      this.appService.logUserAction(
        {},
        this.primaryTicker,
        "",
        "GUIDANCE_NAVIGATION_CLICK",
        {
          documentId: this.documentId,
        },
        "",
        TPR_PAGE,
      );
    }
  }
  onPrevGuidance() {
    if (this.currentGuidance > 1) {
      this.currentGuidance -= 1;
      if (this.dialogRef?.componentInstance) {
        this.dialogRef.componentInstance.data = {
          ...this.dialogRef.componentInstance.data,
          currentGuidance: this.currentGuidance,
        };
      }
      const guidanceId =
        this.guidanceList[this.currentGuidance - 1].start_tag_id;
      const filingsDoc = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementById(guidanceId);
      filingsDoc.scrollIntoView();
      const currFilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(`bkmk_${guidanceId}`);
      const allfilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(
          "bkmk_filings_span_class",
        );
      for (let i = 0; i < allfilingsDocClass.length; i++) {
        allfilingsDocClass[i].style.backgroundColor = "#FFEFCB";
      }
      for (let i = 0; i < currFilingsDocClass.length; i++) {
        currFilingsDocClass[i].style.backgroundColor = "#FFC846";
      }
      this.appService.logUserAction(
        {},
        this.primaryTicker,
        "",
        "GUIDANCE_NAVIGATION_CLICK",
        {
          documentId: this.documentId,
        },
        "",
        TPR_PAGE,
      );
    }
  }

  handleFilingModalCancel() {
    this.isFilingModalVisible = false;
    this.hasGuidance = false;
  }

  hanldeColumnPickerClick() {
    this.isColumnPickerModalVisible = !this.isColumnPickerModalVisible;
  }

  handleColumnDrag(data) {
    const selectedItems = data.componentState.selectedItems;
    // Broker column is fixed, so index 0 is reserved for it, dragged column cannot have zero index
    if (data.event.currentIndex !== 0) {
      moveItemInArray(
        selectedItems,
        data.event.previousIndex,
        data.event.currentIndex,
      );
      this.columnPickerData = this.columnPickerData.map((column) => {
        const index = selectedItems.findIndex(
          (sColumn) => sColumn.id === column.id,
        );
        column.index = index;
        // This component is now aware if some new column was selected/deselected in the modal
        // it would have come to know only on click of apply button. But, now it has to feed in
        // new array of columns, so it should update the selection as well.
        column.isSelected = index !== -1;
        return column;
      });
    }
  }

  hanldeColumnPickerApplyClick(value) {
    const selectedItems =
      value && value.selectedItems ? value.selectedItems : [];
    const selectedColumns = getSelectedColumnPickerItemId(selectedItems);
    this.isTprColumnDetailsSaveApiInProgress = true;
    this.saveTprColumnDetailSubscriber = this.dataService
      .saveTprGridDetails(
        COMPANY_TAB.columnPickerdimensionName,
        selectedColumns,
      )
      .subscribe((response) => {
        if (response && response.status === "success") {
          this.fetchAndUpdateBrokerDetailGrid();
          const { addedItems, removedItems } =
            getAddedAndRemovedColumnPickerItemsLabels(
              this.columnPickerData,
              selectedItems,
            );
          const selectedColumnsLabels = selectedItems.map((item) => item.name);
          this.appService.logUserAction(
            {},
            this.primaryTicker,
            "",
            TPR_LOG_ACTION_FEATURES.companyUpdateColumnPicker,
            {
              selected_columns: selectedColumnsLabels,
              added_columns: addedItems,
              removed_columns: removedItems,
            },
            "",
            TPR_PAGE,
          );
        }
        this.isTprColumnDetailsSaveApiInProgress = false;
      });
    this.handleColumnPickerCancelClick();
  }

  handleColumnPickerResetClick() {
    this.columnPickerData = [...TPR_BROKER_DETAIL_COLUMN_PICKER_ITEMS];
  }

  handleColumnPickerCancelClick() {
    this.columnPickerData = [...this.originallySelectedColumnsPickerData];
    this.isColumnPickerModalVisible = false;
  }

  handleDPCellClick(data) {
    const dp = data.dp;
    if (dp && data.dataExist) {
      if (data.cellId !== this.selectedCellId) {
        this.selectedCellId = data.cellId;
        this.selectedRowId = data.rowId;
        const today = new Date();
        const mm = today.getMonth() + 1;
        const dd = today.getDate();
        const yyyy = today.getFullYear();
        const dpCallPayload = {
          dp: `${dp.id}|${mm}/${dd}/${yyyy}`,
          period: dp.period,
          original_cut: "STD",
          cut: "STD",
          source: data.broker,
          growthType: "Analytics",
          tpr_page: true,
          ticker: this.primaryTicker,
          shouldLog: true,
          extras: `${dp.id}|${dp.period}`,
          isUniversalsliid: true,
          is_universalsliid: true,
          partial_entitled_sid: data.partial_entitled_sid,
        };
        this.store.dispatch(new SetDpParams(dpCallPayload));

        this.appService.logUserAction(
          {},
          this.primaryTicker,
          "",
          TPR_LOG_ACTION_FEATURES.companyDataPointClick,
          {
            datapoint: data.columnLabel,
            value: data.value,
            source: data.broker,
          },
          "",
          TPR_PAGE,
        );
      }
    } else {
      this.selectedCellId = "";
      this.store.dispatch(new DeleteDpParams());
    }
  }

  handleAnalystEmailClick(data) {
    this.appService.logUserAction(
      {},
      this.primaryTicker,
      "",
      TPR_LOG_ACTION_FEATURES.companyAnalystTooltipEmail,
      data,
      "",
      TPR_PAGE,
    );
  }

  handleETEListItemClick(exportType) {
    this.isExportInProgress = true;
    const templateType = "tpr company";
    if (this.sortKey === null || this.sortOrder === null) {
      this.sortKey = BROKER_DETAIL_GRID_DEFAULT_SORTING_ID;
      this.sortOrder = "descend";
    }
    const params = `export_type=${exportType}&template_type=${templateType}&ticker=${this.primaryTicker}&filter=${this.normalizedRatingFilterSelection}&sort_key=${this.sortKey}&order=${this.sortOrder}`;
    this.dataService.exportTprCompany(params).subscribe(
      (res) => {
        if (res["status"] === "success") {
          const fileName = res["filename"];
          const trackerId = res["trackerid"];
          this.appService.logUserAction(
            {},
            "",
            "",
            "TPR_COMPANY_EXCEL_EXPORT",
            {
              templateType: templateType,
              export_type: exportType,
              tracker_id: trackerId,
              file_name: fileName,
            },
            "",
            "TPR COMPANY EXPORT",
          );
          this.isExportInProgress = false;
        } else {
          this.isExportInProgress = false;
          this.snackbarInfo.message =
            "TPR Company export couldn't be downloaded.";
          this.snackbarInfo.type = "failure";
        }
        this.isExportPopoverVisible = false;
      },
      (err) => {
        this.isExportInProgress = false;
        console.error(err);
      },
    );
  }
}
